import { FC } from "react";
import { useTranslation } from "react-i18next";

import Desktop from "../../../../assets/images/content/pillar-1/evolution-of-energy-consumption-and-energy-prices/evolution-of-energy-consumption-barchart-desktop.svg";
import Mobile from "../../../../assets/images/content/pillar-1/evolution-of-energy-consumption-and-energy-prices/evolution-of-energy-consumption-barchart-mobile.svg";

const EvolutionOfEnergyBarchart: FC = () => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col mt-8">
			<img
				className="hidden md:block"
				src={Desktop}
				alt={t("pages.pillar.pillar1.evolutionOfEnergyConsumptionAndEnergyPrices.blocks.visual.alt") as string}
				title={t("pages.pillar.pillar1.evolutionOfEnergyConsumptionAndEnergyPrices.blocks.visual.title") as string}
			/>
			<img
				className="block md:hidden"
				src={Mobile}
				alt={t("pages.pillar.pillar1.evolutionOfEnergyConsumptionAndEnergyPrices.blocks.visual.alt") as string}
				title={t("pages.pillar.pillar1.evolutionOfEnergyConsumptionAndEnergyPrices.blocks.visual.title") as string}
			/>
		</div>
	);
};

export { EvolutionOfEnergyBarchart };